<div class="content-wrapper container-xxl p-0"> 
    <div class="content-body">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Upload Refund Receipt</h4>
            </div>
            <div class="card-body">


<div class="form-group mb-2">
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text">{{currency}}</span>
    </div>
    <input type="text" class="form-control" [(ngModel)]="totalPaid" disabled>
  </div>
</div>




 <!-- Amount Field -->
<div class="form-group mb-2">
<label for="amount" class="form-label">Amount</label>
<input
  type="number"
  id="amount"
  class="form-control"
  placeholder="Enter amount"
  [(ngModel)]="formData.amount"
  name="amount"
  required
  [class.is-invalid]="(+formData.amount || 0) > (+totalPaid || 0)"
/>

<div *ngIf="(+formData.amount || 0) > (+totalPaid || 0)" class="invalid-feedback d-block">
  <small> Amount must be less than or equal to {{ totalPaid }}</small>
</div>

</div>

<!-- Transfer Reference Field -->
<div class="form-group mb-2">
  <label for="transferRef" class="form-label">Transfer Reference</label>
  <input
    type="text"
    id="transferRef"
    class="form-control"
    placeholder="TRF-2025-08-21-0001"
    [(ngModel)]="formData.transferRef"
    name="transferRef"
  />
</div>

<!-- Note Field -->
<div class="form-group mb-2">
  <label for="note" class="form-label">Note</label>
  <textarea
    id="note"
    class="form-control"
    rows="3"
    placeholder="Write a note..."
    [(ngModel)]="formData.note"
    name="note"
  ></textarea>
</div>

<div class="mb-3">
  <label class="form-label" for="receipt">Refund Receipt Photo</label>
  <ngx-dropzone (change)="onSelect($event)" [accept]="'image/*'" [multiple]="false" style="height: 250px;">
    <ngx-dropzone-label>
      <div class="text-center text-muted">
        <i class="bi bi-upload" style="font-size: 2rem;"></i>
        <div class="mt-2">Drag and drop your receipt or click to upload</div>
      </div>
    </ngx-dropzone-label>

    <ngx-dropzone-image-preview *ngFor="let f of files" [file]="f"></ngx-dropzone-image-preview>
  </ngx-dropzone>
</div>

<div class="mt-3">
  <label class="form-label" for="status">Select status</label>
  
  <select class="custom-select" id="status" [(ngModel)]="selectedStatus">
    <option value="">Select your status</option>
    <option value="pending">Pending</option>
    <option value="completed">Completed</option>
  </select>
</div>


<div class="mt-3">
    <div class="d-flex justify-content-end align-items-center" >
      <button type="submit" class="btn btnn " (click)="submitTransaction()" 
      [disabled]=" (+formData.amount || 0) > (+totalPaid || 0)"
      >Submit</button>
    </div>
</div>

            </div>
        </div>
    </div>
</div>